var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCdn77({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "-1.787 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFE115",
    d: "M10.213 0c5.641 0 10.213 4.605 10.213 10.286C20.426 15.967 10.213 24 10.213 24S0 15.967 0 10.286C0 4.605 4.572 0 10.213 0zm0 3.673c-3.438 0-6.226 2.807-6.226 6.271 0 3.463 2.787 6.27 6.226 6.27s6.226-2.807 6.226-6.27c-.001-3.464-2.788-6.271-6.226-6.271z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFE115",
    d: "M10.212 7.114c-1.551 0-2.808 1.267-2.808 2.829s1.257 2.829 2.808 2.829c1.552 0 2.81-1.267 2.81-2.829s-1.258-2.829-2.81-2.829"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCdn77);
export default __webpack_public_path__ + "static/media/cdn77.e6ba8c1734f3af79664ad804db4ac9ea.svg";
export { ForwardRef as ReactComponent };